export const comments_3249786 = {"data":{"data":[],"links":{}}}